module.exports = "<contractors-page></contractors-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/contractors.html
// module id = 2007
// module chunks = 0